<template>
    <div class="toc" ref="toc" :class="{'toc-inline': inline, 'toc-haspart': hasParts}">
        <div class="toc-chapter" v-for="t in toc" :key="t.id">
            <a class="toc-pdflink" target="_blank" :key="`d-${t.id}`" :href="t.pdf" v-if="t.pdf">↓&nbsp;{{$root.t('menu_pdf')}}</a>
            <a @click.stop="toggle" :class="`toc-chapter-level toc-chapter-level-${t.level}${active == t.id ? ' toc-chapter-level-active' : ''}${t.pdf ? ' toc-chapter-level-haspdf' : ''}${t.isPart ? ' toc-chapter-part' : ''}`" :href="t.id">
                <span v-html="t.text"/>
            </a>
            <template v-for="tt in t.toc">
                <a @click.stop="toggle" v-if="tt.level < maxLevel" :class="`toc-chapter-level toc-chapter-level-${tt.level}${active == tt.id ? ' toc-chapter-level-active' : ''}`" :href="tt.id" :key="tt.id">
                    <span v-html="tt.text"/>
                </a>
            </template>
        </div>
        <div class="toc-appendix" v-if="bibliography || index || images || acknowledgments || imprint">
            <div :class="`annextitle toc-chapter-level toc-chapter-level-0${active == '#__annex' ? ' toc-chapter-level-active' : ''}`">
              <a @click.stop="toggle"  href="#__annex" v-html="$root.t('context_annex')"/>
              <a class="toc-pdflink" target="_blank" :href="annexPDF" v-if="annexPDF">↓&nbsp;{{$root.t('menu_pdf')}}</a>
            </div>
            <a @click.stop="toggle" :class="`toc-appendix-level${active == '#__bibliography' ? ' toc-chapter-level-active' : ''}`" v-if="bibliography" href="#__bibliography"><span>{{$root.t('context_bibliography')}}</span></a>
            <a @click.stop="toggle" :class="`toc-appendix-level${active == '#__index' ? ' toc-chapter-level-active' : ''}`" v-if="index" href="#__index"><span>{{$root.t('context_index')}}</span></a>
            <a @click.stop="toggle" :class="`toc-appendix-level${active == '#__credits' ? ' toc-chapter-level-active' : ''}`" v-if="images" href="#__credits"><span>{{$root.t('context_credits')}}</span></a>
            <a @click.stop="toggle" :class="`toc-appendix-level${active == '#__acknowledgments' ? ' toc-chapter-level-active' : ''}`" v-if="acknowledgments" href="#__acknowledgments"><span>{{$root.t('context_acknowledgments')}}</span></a>
            <a @click.stop="toggle" :class="`toc-appendix-level${active == '#__imprint' ? ' toc-chapter-level-active' : ''}`" v-if="imprint" href="#__imprint"><span>{{$root.t('context_imprint')}}</span></a>
        </div>
        <div class="toc-footer" v-if="citation">
            <div>
            <span v-html="citation"/>
            <a :href="doi" target="_blank" v-html="doi" v-if="doi"/>
            </div>
        </div>
        <div class="toc-spacer" v-else/>
    </div>
</template>

<script>

export default {
  name: 'Toc',
  props: [
    'toc', 'bibliography', 'index', 'images', 'active', 'imprint', 'hasParts', 'acknowledgments', 'citation', 'doi', 'meta', 'inline', 'annexPDF'
  ],
  data () {
    return ({
      maxLevel: this.meta.Options.BookType === 'Anthology' ? 1 : 3
    })
  },
  methods: {
    toggle (e) {
      e.preventDefault()
      try {
        if (e.currentTarget.attributes && e.currentTarget.attributes.href && e.currentTarget.attributes.href.value) {
          const _el = document.getElementById(e.currentTarget.attributes.href.value.replace('#', ''))
          if (_el) this.$root.$emit('scroll-to', {element: _el, hash: e.currentTarget.attributes.href.value})
        }
      } catch (err) {
        console.warn(err)
      }
      this.$root.$emit('context-opened', false)
      this.$router.push({name: 'book',
        params: {...this.$route.params,
          extraBook: undefined,
          extraChapter: undefined,
          extraItem: undefined
        }})
    }
  }
}
</script>

<style lang="scss">

@import '../main';
.toc {
  display: flex;
  flex-direction: column;
  height: 100%;
  @include tocfont();
  &-pdflink {
    position: absolute;
    top: calc(1px + var(--padding-05));
    right: 0px;
  }
  &:not(.toc-inline) > div:first-child {
    & > a {
      padding-top: 0px !important;
      margin-top: calc(-1 * var(--padding-025)) !important;
      &.toc-pdflink {
        top: 0px !important;
      }
    }
  }
  a {
      &:active,
      &:focus,
      &:hover {
        color: inherit !important;
      }
  }
  &-haspart {
    .toc {
      &-appendix,
      &-chapter {
        &-part {
          & > span {
            padding-left: 0 !important;
          }
          &.toc-chapter-level-active:before {
            position: relative !important;
            left: 0px !important;
          }
        }
        &-level {
          span {
            padding-left: var(--padding-20);
            @include sm() {
              padding-left: var(--padding);
            }
            display: block;
          }
          &.toc-chapter-level-active:before {
            position: absolute;
            left: var(--padding-20);
            @include sm() {
              left: var(--padding);
            }
          }
        }
      }
      &-appendix {
        padding-left: var(--padding-20);
        @include sm() {
          padding-left: var(--padding);
        }
        span {
          margin-left: 0 !important;
        }
      }
    }
    .annextitle {
        margin-left: 0 !important;
        position: relative;
        span {
          padding-left: 0 !important;
        }
        &.toc-chapter-level-active:before {
          position: relative !important;
          left: 0px !important;
        }
    }
  }
  &-appendix,
  &-chapter {
    margin-right: calc(var(--menuwidth-hidden) + var(--padding));
    position: relative;
    @include sm() {
      margin-right: calc(var(--menuwidth-hidden) + var(--padding-025));
    }
    font-weight: bold;
    flex-shrink: 4;
    &-level {
      display: block;
      margin-left: var(--padding-20);
      @include sm() {
        margin-left: var(--padding);
      }
      &-haspdf {
        padding-right: var(--padding-40);
      }
      &-author {
        display: block;
        text-transform: none;
      }
      &-active {
        &:before {
          content: "●\00a0";
          float: left;
        }
      }
      &-0 {
        text-transform: uppercase;
        padding-top: var(--padding-05);
        margin-top: var(--padding-05);
        border-top: 1px solid var(--context-tray-font-color);
      }
      &-1,
      &-2 {
        span {
          margin-left: var(--menuwidth-hidden);
          display: block;
          text-indent: calc(var(--menuwidth-hidden)*-1);
          padding-left: var(--menuwidth-hidden);
        }
      }
      strong {
        font-weight: bold;
      }
    }
    &:first-child > a:last-child {
      margin-top: 0;
      border: none;
    }
  }
  &-spacer {
    min-height: var(--menuwidth-hidden);
  }
  &-footer {
    @include tocfooterfont;
    text-transform: none;
    padding-top: var(--padding-05);
    padding-left: var(--padding-20);
    padding-right: calc(var(--menuwidth-hidden) + var(--padding));
    padding-bottom: var(--padding);
    @include sm() {
      padding-left: var(--padding);
      padding-right: calc(var(--menuwidth-hidden) + var(--padding-025));
    }
    width: 100%;
    box-sizing: border-box;
    flex-grow: 4;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    //min-height: var(--padding-40);
    div {
      border-top: 1px solid;
      margin-top: var(--padding);
      padding-top: var(--padding-05);
      display: block;
      bottom: 0px;
      img {
        max-width: 25%;
        margin-top: var(--padding-05);
        margin-bottom: var(--padding-05);
      }
    }
  }
  &-inline {
    background: var(--paper-color);
    transform: translateZ(0);
    z-index: 4;
    position: relative;
    display: block;
    padding: var(--padding-30) calc(var(--menuwidth-right) + var(--menuwidth-hidden)) var(--padding-30) calc(var(--menuwidth-left) + var(--menuwidth-hidden));
    @include sm() {
      padding-left: calc(var(--menuwidth-hidden) + var(--padding-05));
      padding-right: calc(var(--menuwidth-hidden) + var(--padding-05));
      padding-top: 0
    }
    .toc-footer {
      padding-left: 0;
      padding-right: 0;
      display: block;
      max-width: var(--paperwidth);
      width: 100%;
      margin: auto;
    }
    .toc-spacer {
      display: none;
    }
    .toc-appendix-level,
    .toc-chapter-level {
      margin-left: 0;
    }
    .toc-appendix,
    .toc-chapter {
      margin-right: 0;
      width: 100%;
      max-width: var(--paperwidth);
      margin: auto;
      &-level {
        &-active {
          &:before {
            display: none;
          }
        }
      }
    }
    &.toc-haspart {
      .toc {
        &-appendix,
        &-chapter {
          &-part {
            /*span {
              padding-left: 0 !important;
            }*/
            &.toc-chapter-level-active:before {
              position: relative !important;
            }
          }
          &-level {
            span {
              padding-left: var(--padding-20);
              @include sm() {
                padding-left: var(--padding);
              }
              display: block;
            }
            &.toc-chapter-level-active:before {
              position: absolute;
              left: 0;
            }
          }
        }
        &-appendix {
          padding-left: 0;
          @include sm() {
            padding-left: 0;
          }
          span {
            margin-left: 0 !important;
          }
          &-level {
            span {
              margin-left: var(--menuwidth-hidden) !important;
              @include sm() {
                margin-left: var(--padding-20) !important;
              }
            }
          }
        }
      }
      .annextitle {
          margin-left: 0 !important;
          span {
            padding-left: 0 !important;
          }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Toc.vue